import React, { createContext } from 'react';
import PropTypes from 'prop-types';

const propTypes = {
  children: PropTypes.node.isRequired,
  dispatch: PropTypes.func.isRequired,
  value: PropTypes.shape({}).isRequired,
};

const authentication = {
  isLoggedIn: false,
};

export const AuthContext = createContext(authentication);

export const DispatchContext = createContext(null);

export const AuthProvider = ({ children, dispatch, value }) => (
  <DispatchContext.Provider value={dispatch}>
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  </DispatchContext.Provider>
);

AuthProvider.propTypes = propTypes;
